<template>
  <div class="events-page">
    <header class="events-header">
      <button
        type="button"
        class="back-btn"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ $t('home.activity') }}</h1>
    </header>

    <main class="events-main">
      <van-empty
        v-if="empty"
        :description="$t('orders.noOrders')"
      />
      <section
        v-else
        class="events-list"
      >
        <button
          v-for="(item, index) in list"
          :key="item.id"
          type="button"
          class="event-card"
          @click="openArticle(item.id)"
        >
          <span
            class="event-icon"
            :class="'tone-' + (index % 5)"
          >
            <van-icon name="volume-o" />
          </span>
          <span class="event-content">
            <span class="event-title">{{ item.title }}</span>
            <span
              v-if="item.summary"
              class="event-summary"
            >{{ item.summary }}</span>
            <!-- <span class="event-time">{{ item.time }}</span> -->
          </span>
          <van-icon
            class="event-arrow"
            name="arrow"
          />
        </button>
      </section>
    </main>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import { Empty, Icon } from 'vant';

Vue.use(Empty).use(Icon);

export default {
  name: 'Events',
  data() {
    return {
      list: [],
      empty: false,
    };
  },
  created() {
    if (this.$parent && this.$parent.footer) {
      this.$parent.footer('events', true);
    }
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/index/events', {}, null, true).then((res) => {
        const list = res.data.list || [];
        this.list = list;
        this.empty = list.length === 0;
      }).catch(() => {
        this.list = [];
        this.empty = true;
      });
    },
    openArticle(id) {
      if (!id) return;
      this.$router.push('/about/' + id);
    },
  },
};
</script>

<style lang="less" scoped>
.events-page {
  min-height: 100vh;
  padding-bottom: 88px;
  box-sizing: border-box;
  background: #f4f5fb;
  color: #061429;
}

.events-header {
  position: sticky;
  top: 0;
  z-index: 10;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f8fd;
}

.events-header h1 {
  max-width: 72%;
  margin: 0;
  overflow: hidden;
  color: #202637;
  font-size: 14px;
  font-weight: 500;
  line-height: 50px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.back-btn {
  position: absolute;
  left: 8px;
  top: 10px;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #071426;
  font-size: 22px;
}

.events-main {
  padding: 14px 13px 0;
  box-sizing: border-box;
}

.events-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.event-card {
  width: 100%;
  min-height: 88px;
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr) 14px;
  align-items: center;
  column-gap: 12px;
  padding: 14px 14px;
  border: 0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(30, 45, 82, .045);
  text-align: left;
}

.event-icon {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  color: #fff;
  font-size: 18px;
}

.tone-0 {
  background: linear-gradient(135deg, #6199ff 0%, #246cf2 100%);
}

.tone-1 {
  background: linear-gradient(135deg, #42d7dc 0%, #17a8cc 100%);
}

.tone-2 {
  background: linear-gradient(135deg, #70d87b 0%, #2fac59 100%);
}

.tone-3 {
  background: linear-gradient(135deg, #ffbd61 0%, #ff8e2b 100%);
}

.tone-4 {
  background: linear-gradient(135deg, #9a86ff 0%, #7662f7 100%);
}

.event-content {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.event-title {
  overflow: hidden;
  color: #16233a;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.event-summary {
  display: -webkit-box;
  overflow: hidden;
  margin-top: 4px;
  color: #758298;
  font-size: 12px;
  line-height: 18px;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.event-time {
  margin-top: 6px;
  color: #99a3b3;
  font-size: 12px;
  line-height: 18px;
}

.event-arrow {
  color: #c4cad4;
  font-size: 16px;
}
</style>
